import Reveal from "./Reveal";
import { useNavigate } from "react-router-dom";

export default function ForCompanies() {
  const navigate = useNavigate();
  return (
    <section
      className="border-y border-clay/60 bg-sand/50 py-20 sm:py-24"
      data-testid="companies-section"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="img-frame overflow-hidden rounded-sm border border-clay/60 transition-transform duration-700 ease-out hover:scale-[1.02]">
              <img
                src="/media/companies-concept.jpg"
                alt="Concept for a large workplace piece — a driftwood arch with engraved name tags, fern stones, feathers and brass details"
                className="w-full object-cover"
                data-testid="companies-teaser-image"
              />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.1}>
            <p className="ttwk-label" data-testid="companies-eyebrow">
              For companies
            </p>
            <p className="mt-6 max-w-xl font-serif text-3xl font-light italic leading-snug sm:text-4xl">
              Some things belong to one person. Others belong to a whole group of people.
            </p>
            <button
              onClick={() => navigate("/companies")}
              className="mt-10 rounded-full bg-terracotta px-10 py-4 text-[11px] uppercase tracking-[0.2em] text-cream transition-colors duration-300 hover:bg-espresso"
              data-testid="companies-cta"
            >
              Read about Collective Pieces
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
